import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { RocheUIDate as t } from "../date/roche-date.js";
import s from "./roche-subline.module.scss.js";
const d = ({
  author: c,
  authorDescription: o,
  attributionPhrase: a,
  displayDate: l,
  dateTimeValue: n,
  children: r
}) => /* @__PURE__ */ i("div", { className: s.subline, children: [
  a && /* @__PURE__ */ e("h3", { className: s["subline__attribution-phrase"], children: a }),
  /* @__PURE__ */ i("div", { className: s["subline__author-container"], children: [
    r && /* @__PURE__ */ e("div", { className: s.subline__avatar, children: r }),
    /* @__PURE__ */ i("div", { className: s["subline__author-description-container"], children: [
      /* @__PURE__ */ e("p", { className: s.subline__author, children: c }),
      /* @__PURE__ */ e("p", { className: s["subline__author-description"], children: o }),
      l && n && /* @__PURE__ */ e("div", { className: s.subline__date, children: /* @__PURE__ */ e(t, { dateTimeValue: n, displayDate: l }) })
    ] })
  ] })
] });
export {
  d as RocheUISubline
};
